// Like FormulaCalculator, but with percentage support
// The BE doesn't support percentages in formulas that's why we don't use
// FormulaCalculator instead of this function in the FE.

// Evaluates a user-entered expression like "100 * 2" or "100 + 10%".
//
// Supported operators: +, -, *, /
// Percentage suffix: "A+B%" or "A-B%" uses A as the base (e.g. "100+10%" → 110).
// Percentages are only supported at the end of an expression with a preceding number.
//
// Returns null for empty, invalid, or non-finite results.
export function evaluateExpression(expr: string): number | null {
  const cleaned = expr.replace(/\s/g, '')
  if (!cleaned) return null

  let processed = cleaned

  // "BASE op PCT%" — use BASE as the percentage base (e.g. "100+10%" → 110)
  const exprPctMatch = cleaned.match(
    /^(.*?)(\d+(?:\.\d*)?)([+-])(\d+(?:\.\d*)?)%$/
  )
  if (exprPctMatch) {
    const [, prefix, base, op, pct] = exprPctMatch
    processed = `${prefix}${base}${op}((${prefix}${base})*${pct}/100)`
  }

  if (processed.includes('%')) return null

  // Only allow digits, arithmetic operators, parentheses, and decimal points
  if (!/^[\d+\-*/().]+$/.test(processed)) return null

  try {
    // Safe: % has been expanded to arithmetic, and the regex above ensures no
    // identifiers or other code constructs remain before we reach this point.
    // eslint-disable-next-line @typescript-eslint/no-implied-eval, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const result = Function(`"use strict"; return (${processed});`)()
    return typeof result === 'number' && Number.isFinite(result) ? result : null
  } catch {
    return null
  }
}
